import isNumber from 'lodash/isNumber';

function getRawValue(spec, prop) {
  if (
    typeof spec[prop] != 'undefined' &&
    spec[prop].value !== undefined &&
    spec[prop].value !== null
  ) {
    return spec[prop].value;
  } else {
    return '';
  }
}

export function valFormatter(spec) {
  return function (prop, defaultValue, options) {
    if (typeof options !== 'object') {
      options = {};
    }

    let value = '',
      unit = '';

    if (typeof spec[prop] !== 'undefined' && spec[prop].value !== undefined) {
      value = spec[prop].value;
      if (spec[prop].unit) {
        unit = ' ' + spec[prop].unit;
      }
    } else {
      value = defaultValue || ' - ';
    }

    if (isNumber(value)) {
      if (typeof options.money !== 'undefined') {
        value = '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      } else if (typeof options.number_format !== 'undefined') {
        value = value.toFixed(parseInt(options.number_format, 10));
      }
    }

    if (value === null || value === undefined) {
      return '';
    }

    return value + '' + unit;
  };
}

export function boolFormatter(spec) {
  return function (prop, a, b) {
    let value = null;
    if (typeof spec[prop] !== 'undefined' && spec[prop].value !== undefined) {
      value = spec[prop].value;
    }

    if (value === null) {
      return '';
    }

    if (typeof value === 'string') {
      let stringVal = value.trim().toLowerCase();
      if (stringVal === 'yes' || stringVal === 'on') {
        return a;
      } else {
        return b;
      }
    } else {
      return value ? a : b;
    }
  };
}

export function maxFormatter(spec) {
  return function (prop1, prop2) {
    const val1 = getRawValue(spec, prop1);
    const val2 = getRawValue(spec, prop2);

    let unit = '';
    if (spec[prop1] && spec[prop1].unit !== undefined) {
      unit = ' ' + spec[prop1].unit;
    }

    if (!isNumber(val1) && !isNumber(val2)) {
      return '-';
    } else if (!isNumber(val1)) {
      return val1 + '' + unit;
    } else if (!isNumber(val2)) {
      return val2 + '' + unit;
    } else {
      return Math.max(val1, val2) + ' ' + unit;
    }
  };
}

export function expandCamelCase(text) {
  // remove non-word chars
  text = text.replace(/_|\W+/g, '');
  // make the first character upper case
  text = text.slice(0, 1).toUpperCase() + text.slice(1);
  // split into chunks by capital letters
  const words = text.match(/([A-Z]+[a-z0-9]*)/g);
  // re-assemble
  return words.join(' ');
}

export const formatDate = (date, format = 'date') => {
  switch (format) {
    case 'time':
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = ' am';
      if (hours > 12) {
        hours -= 12;
        ampm = ' pm';
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      return hours + ':' + minutes + ampm;
    case 'datetime':
      return formatDate(date, 'date') + ' at ' + formatDate(date, 'time');
    case 'date':
    default:
      return (
        date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      );
  }
};

/* For turning numbers into the ordinal version of it - thanks jody! */
export function nth(input) {
  let asString = '';

  switch (typeof input) {
    case 'number':
      asString = input.toString();
      break;
    case 'string':
      asString = input;
      break;
    default:
      return '';
  }

  const lastNum = parseInt(asString.substring(asString.length - 1));
  const lastTwo = parseInt(asString.substring(asString.length - 2));
  let suffix = '';

  if (isNaN(lastNum)) {
    return asString;
  }

  if (lastTwo > 9 && lastTwo < 20) {
    suffix = 'th';
  } else {
    switch (lastNum) {
      case 1:
        suffix = 'st';
        break;
      case 2:
        suffix = 'nd';
        break;
      case 3:
        suffix = 'rd';
        break;
      default:
        suffix = 'th';
        break;
    }
  }

  return asString + suffix;
}

/* For rounding a number (up or down) to the nearest interval */
export function nearestUp(n, interval) {
  return Math.ceil(n / interval) * interval;
}
export function nearestDown(n, interval) {
  return Math.floor(n / interval) * interval;
}

/* New functions/formatters for formatting a value with units */

// only instantiate one per page
const currencyFormatter = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatWithUnits(value, units) {
  switch (units) {
    case '$':
      return currencyFormatter.format(value);
    default:
      return `${value} ${units}`;
  }
  return tick;
}
